import React from "react";
import "../LoanEMICalculators.css";
import { Typography, Grid } from "@mui/material"; // ✅ Legacy Grid
import { ArrowForwardRounded } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { EligibilityLinks } from "../CalculatorsPageLinks";

const LoanEligibilityCalculators = () => {
  const navigate = useNavigate();

  return (
    <div className="pages_box__main_container">
      <div className="pages_box__container">
        <div className="d-flex flex-column gap-3">
          <Typography
            sx={{
              fontSize: {
                xs: 30,
                lg: 35,
                xl: 40,
              },
              fontWeight: 600,
              color: "#59266D",
              lineHeight: { xs: "35px", lg: "40.2px", xl: "49.2px" },
              fontFamily: "Archivo",
            }}
          >
            Loan Eligibility Calculators
          </Typography>
          <Typography
            sx={{
              fontSize: { xs: 16, sm: 18 },
              lineHeight: { xs: "20px", sm: "24px" },
              fontWeight: 400,
              color: "#74589B",
              fontFamily: "Archivo",
            }}
          >
            Eligibility Calculators quickly estimate your qualification for
            loans, mortgages, or financial programs. Enter details like income,
            expenses, and credit score for instant results. These tools make
            financial planning simple and hassle-free. They’re free, easy to
            use, and accessible online. Start making informed decisions today!
          </Typography>
        </div>

        <div className="pages_cards_grid__container w-100 mt-5">
          <Grid container spacing={5}>
            {EligibilityLinks &&
              EligibilityLinks.map((item) => (
                <Grid item key={item.id} xs={12} sm={6} md={4}>
                  <button
                    className="calculator_card__box w-100 p-2 py-3 p-sm-3"
                    onClick={() => navigate(`${item.link}`)}
                  >
                    <div className="d-flex flex-row gap-2 align-items-center justify-content-between">
                      <p
                        style={{
                          fontSize: 16,
                          color: "#1f1f1f",
                          lineHeight: "20px",
                          fontWeight: 500,
                          fontFamily: "Archivo",
                        }}
                        className="calculator_name m-0"
                      >
                        {item.calculatorName}
                      </p>
                      <div className="rounded">
                        <ArrowForwardRounded sx={{ color: "#59266D" }} />
                      </div>
                    </div>
                  </button>
                </Grid>
              ))}
          </Grid>
        </div>
      </div>
    </div>
  );
};

export default LoanEligibilityCalculators;
